<markant-dialog
  data-cy="approve-dialog"
  *ngIf="open"
  [open]="true"
  [ngClass]="customClassName"
  [headTitle]="headline"
  (close)="closeDialog()"
>
  <p class="dialog-text p-with-line-breaks" [innerHTML]="text"></p>
  <ng-content></ng-content>
  <div slot="footer">
    <markant-button
      data-cy="approve-dialog-cancel-button"
      [colorScheme]="cancelButtonStyles.colorScheme"
      variant="clear"
      [ngClass]="cancelButtonStyles.class"
      (click)="closeDialog()"
      (keydown.enter)="closeDialog()"
    >
      {{ cancelButtonText }}
    </markant-button>

    <markant-button
      data-cy="approve-dialog-approve-button"
      [colorScheme]="approveButtonStyles.colorScheme"
      [ngClass]="approveButtonStyles.class"
      [disabled]="isButtonDisabled"
      [loading]="isButtonLoading"
      (click)="approve()"
      (keydown.enter)="approve()"
    >
      <ng-content select="[approve-button]"></ng-content>
      {{ approveButtonText }}
    </markant-button>
  </div>
</markant-dialog>
